<template>
      <div class="group-chat-wrapper">
        <!-- Header -->
        <div class="chat-header">
          <div class="header-left">
            <span class="back" @click="backLounge">
              ← Back
            </span>
          
          </div>
        </div>
    
        <!-- Chat Body -->
        <div class="chat-body">
    
          <!-- Date Divider -->
          <div class="date-divider">
            <span></span>
          </div>
    
          <!-- Messages -->
          <div
            v-for="(msg, index) in messages"
            :key="index"
            class="chat-row"
            :class="{ me: Number(msg.sender_id) === Number(userId) }"
          >

            <!-- LEFT (Others) -->
            <span v-if="msg.account_type === 'escort' || msg.account_type === 'content-creator'">
              <img
              v-if="Number(msg.sender_id) !== Number(userId)"
              :src="msg.avatar"
              class="avatar"
              style="cursor: pointer;"
              @click="view_profile(msg.profile_id, msg.name)"
            />
            </span>
            <span v-else>
              <img
              v-if="Number(msg.sender_id) !== Number(userId)"
              :src="msg.avatar"
              class="avatar"
            />
            </span>
            

            <!-- Bubble -->
            <div
              class="chat-bubble"
              :class="{ me: Number(msg.sender_id) === Number(userId) }"
              style="background-color: #2f6fed"
            >
              <strong v-if="Number(msg.sender_id) !== Number(userId)">
                {{ msg.name }}
              </strong>

              <p>{{ msg.message }}</p>

              <!-- IMAGE -->
              <img
              v-if="msg.media_url && msg.message_type === 'image'"
              :src="msg.media_url"
              class="chat-image"
              />

              <!-- FILE -->
              <a
              v-if="msg.media_url && msg.message_type === 'file'"
              :href="msg.media_url"
              target="_blank"
              class="file-link"
              >
              📎 Download File
              </a>

              <span class="time">
                {{ formatTime(msg.time) }}
              </span>
            </div>

            <!-- RIGHT (Me) -->
            <span v-if="msg.account_type === 'escort' || msg.account_type === 'content-creator'">
              <img
              v-if="Number(msg.sender_id) === Number(userId)"
              :src="msg.avatar"
              class="avatar"
              style="cursor: pointer; background-color: #2f2f37"
              @click="view_profile(msg.profile_id, msg.name)"
            />
            </span>
            <span v-else>
              <img
              v-if="Number(msg.sender_id) === Number(userId)"
              :src="msg.avatar"
              class="avatar"
              style="background-color: #2f2f37"
            />
            </span>
            
          </div>
        </div>
        <!-- EMOJI PICKER -->
        <div v-if="showEmoji" class="emoji-box">
          <span
          v-for="emoji in emojis"
          :key="emoji"
          @click="addEmoji(emoji)"
          >{{ emoji }}</span>
        </div>
    
        <!-- Input Bar -->
        <div class="chat-input-bar">
    
          <!-- EMOJI -->
          <span @click="toggleEmoji">
            <i class="fa fa-smile icon"></i>
          </span>
         
    
          <input
            v-model="newMessage"
            type="text"
            placeholder="Type a Message"
            @keyup.enter="sendMessage"
          />
    
          <div class="actions">
           <!-- FILE ATTACH -->
            <label class="icon">
            <i class="fa fa-paperclip"></i>
            <input
            type="file"
            hidden
            @change="handleFile"
            />
            </label>

            <!-- CAMERA -->
            <label class="icon">
            <i class="fa fa-camera"></i>
            <input
            type="file"
            accept="image/*"
            capture="environment"
            hidden
            @change="handleCamera"
            />
            </label>
    
            <button class="send-btn" @click="sendMessage">
              <i class="fa fa-paper-plane"></i>
            </button>
          </div>
    
        </div>
    
      </div>
</template>
    
<script>
  import socket from "@/socket";

  export default {
    name: "GroupChat",
  
    data() {
      return {
        userId: localStorage.getItem("userid"),
        role: '',
        name: '',
        newMessage: "",
        messages: [],
        selectedFile: null,
        showEmoji: false,

        emojis: [
          // Faces
          "😀","😁","😂","🤣","😃","😄","😅","😆","😉","😊",
          "🙂","🙃","😋","😎","😍","😘","🥰","😗","😙","😚",
          "🤗","🤩","🤔","🫢","🤭","🤫","🤨","😐","😑","😶",
          "😏","😒","🙄","😬","😮‍💨","🤥","😌","😔","😪","🤤",
          "😴","😷","🤒","🤕","🤢","🤮","🤧","🥵","🥶","😵",
          "🤯","😳","🥺","😢","😭","😤","😡","😠","🤬",

          // Gestures
          "👍","👎","👌","✌️","🤞","🤟","🤘","🤙",
          "👏","🙌","🫶","🙏","💪","👊","✊","🤛","🤜",

          // Love
          "❤️","🧡","💛","💚","💙","💜","🖤","🤍","🤎",
          "💔","❣️","💕","💞","💓","💗","💖","💘","💝",

          // Reactions
          "🔥","💯","✨","⭐","🌟","⚡","💥","🎯",

          // Celebration
          "🎉","🎊","🥳","🍾","🎂","🍰","🧁","🍻","🥂",

          // Animals (fun reactions)
          "😺","😸","😹","😻","😼","😽","🙀","😿","😾",

          // Misc reactions
          "👀","🫣","🫡","🫠","🫥","🫤","🥱","😇","🤠","🥸"
        ]
      };
    },
    beforeMount(){
      this.userId = localStorage.getItem("userid"); 
    },
    async mounted(){
      this.user_email = localStorage.getItem("email");
      this.name = localStorage.getItem("name"); 
      this.role = localStorage.getItem("role");
      await this.fetchMessages()

      /* SOCKET LISTENER */
      socket.on("groupMessage", msg => {
        this.messages.push({
          sender_id: msg.sender_id,
          name: msg.name,
          message: msg.message,
          time: msg.created_at,
          avatar: msg.picture_url
            ? msg.picture_url
            : "https://i.pravatar.cc/100?img=12",

          color:
            msg.sender_id == this.userId
              ? "#2f2f37"
              : "#2f6fed",
          message_type: msg.message_type,
          media_url: msg.media_url,
          account_type: msg.account_type,
          profile_id: msg.profile_id
        });

        this.scrollToBottom();
      });

    },
  
    methods: {
      async fetchMessages() {
        try {
          const res = await this.$http.get(
            `/group-messages/messages`
          );

          this.messages = res.data.data.map(msg => ({
            sender_id: msg.sender_id,
            name: msg.name,
            message: msg.message,
            time: msg.created_at,
            avatar: msg.profilepic
              ? msg.profilepic
              : "https://i.pravatar.cc/100?img=1",
            color: msg.color,
            message_type: msg.message_type,
            media_url: msg.media_url,
            account_type: msg.account_type,
            profile_id: msg.profile_id
          }));

          this.scrollToBottom();

        } catch (err) {
          console.log(err);
        }
      },

      /* SEND */
      async sendMessage() {
        if (!this.newMessage && !this.selectedFile) return;

        const formData = new FormData();
        formData.append("sender_id", this.userId);
        formData.append("name", this.name);
        formData.append("message", this.newMessage);
        formData.append("role", this.role);
        formData.append("avatar", "-");
        formData.append("color", "#444");


        if (this.selectedFile) {
          formData.append("group_chat_gallery_video", this.selectedFile);
        }


        await this.$http.post(
        "/group-messages/send",
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
        );


        this.newMessage = "";
        this.selectedFile = null;
      },

      view_profile(id, name){
        this.$router.push(`/escort-profile/${id}/${name}`)
      },

      /* FILE */
      handleFile(e) {
        this.selectedFile = e.target.files[0];
      },

      /* CAMERA */
      handleCamera(e) {
        this.selectedFile = e.target.files[0];
      },


      /* EMOJI */
      toggleEmoji() {
        this.showEmoji = !this.showEmoji;
      },


      addEmoji(emoji) {
        this.newMessage += emoji;
        this.showEmoji = false;
      },
  
      formatTime(time) {
        return new Date(time).toLocaleString();
      },
      backLounge(){
        this.$router.push("/vip-lounge")
      }

    }
  };
</script>
  
<style scoped>

  .group-chat-wrapper {
    height: 100vh;
    background: #0f0f17;
    display: flex;
    flex-direction: column;
    color: #fff;
    width: 100%;
    padding: 0 0.5rem 0 0.5rem;
  }
  
  /* Header */
  .chat-header {
    margin-top: 100px;
    padding: 15px 20px;
    background: #07070c;
    border-bottom: 1px solid #222;
  }
  
  .header-left {
    display: flex;
    align-items: center;
    gap: 15px;
  }
  
  .back {
    cursor: pointer;
    opacity: 0.7;
  }
  
  /* Body */
  .chat-body {
    flex: 1;
    overflow-y: auto;
    padding: 20px;
  }
  
  /* Date divider */
  .date-divider {
    text-align: center;
    margin: 20px 0;
    position: relative;
  }
  
  .date-divider span {
    background: #0f0f17;
    padding: 0 10px;
    color: #aaa;
    font-size: 13px;
  }
  
  /* Rows */
  .chat-row {
    display: flex;
    align-items: flex-end;
    margin-bottom: 20px;
    gap: 10px;
  }
  
  .chat-row.me {
    justify-content: flex-end;
  }
  
  /* Avatar */
  .avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  
  /* Bubble */
  .chat-bubble {
    max-width: 60%;
    padding: 12px 15px;
    border-radius: 12px;
    font-size: 14px;
    position: relative;
  }
  
  .chat-row.me .chat-bubble {
    background: #444 !important;
  }
  
  /* Time */
  .time {
    display: block;
    font-size: 11px;
    opacity: 0.7;
    margin-top: 5px;
  }
  
  /* Input bar */
  .chat-input-bar {
    display: flex;
    align-items: center;
    padding: 10px 15px;
    background: #1a1a22;
    gap: 10px;
  }
  
  .chat-input-bar input {
    flex: 1;
    background: transparent;
    border: none;
    outline: none;
    color: #fff;
  }
  
  /* Icons */
  .icon {
    opacity: 0.7;
    cursor: pointer;
    margin-left:4px ;
  }
  
  /* Send */
  .send-btn {
    background: #ff4f87;
    border: none;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    color: #fff;
    margin-left:4px;
  }
  .chat-image{
    width: 80%;
  }

  @media screen and (max-width: 700px) {
  .chat-input-bar{
    padding: 10px 5px;
  }
  .send-btn {
    width: 30px;
    height: 30px;
  }
  .fa-paper-plane{
    width: 20px;
  }
  .chat-image{
    width: 100%;
  }
}
  </style>
